<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import { required } from "vuelidate/lib/validators";
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/es';
import moment from 'moment';
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

import { categories } from "./data-calendar";

/**
 * Calendar component
 */
export default {
    components: { FullCalendar, Multiselect, DatePicker, moment },
    data() {
        return {
            title: "Calendar",
            items: [
                {
                text: "Calendar",
                active: true
                }
            ],
            eventTimeFormat: { // like '14:30:00'
                hour: '2-digit',
                minute: '2-digit'
            },
            calendarWeekends: true,
            calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                bootstrapPlugin,
                listPlugin
            ],
            themeSystem: "bootstrap",
            calendarEvents: [],
            showModal: false,
            eventModal: false,
            categories: categories,
            submitted: false,
            submit: false,
            newEventData: {},
            edit: {},
            deleteId: {},
            event: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            editevent: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:'',
                codigo:'',
                rbd_colegio:'',
                colegio:'',
                comuna:''
            },
            validations: {
                event: {
                    user_id: {required},
                    servicio: {required},
                    profesional: {required},
                    hora: {required}
                },
            },
            usersOptions:[],
            serviciosOptions:[],
            profesionalOptions:[],
            tipos:[],
            subtipos:[],
            copiado:false,
            sede:'',
            sedes:[],
            coordinador:'',
            allCoordinadores: [],
            coordinadores:[],
            unidad:'',
            unidades:['DAE PM', 'DAE Valdivia', 'Admision y Matricula', 'Difusion', 'Difusion PM', 'Sin Unidad'],
            calendarEventsFiltrados:[],
            isSmallScreen: window.innerWidth < 768,
            showColumnModal: false,
            tipoDescarga: 'mes',
            availableColumns: [
                { key: 'Actividad', label: 'Actividad', selected: true },
                { key: 'Codigo', label: 'Código', selected: true },
                { key: 'Fecha Inicio', label: 'Fecha Inicio', selected: true },
                { key: 'Fecha Termino', label: 'Fecha Término', selected: true },
                { key: 'Colegio', label: 'Colegio', selected: true },
                { key: 'Comuna', label: 'Comuna', selected: true },
                { key: 'Tipo', label: 'Tipo', selected: true },
                { key: 'Curso', label: 'Curso', selected: true },
                { key: 'Correo Notificaciones', label: 'Correo Notificaciones', selected: true },
                { key: 'Telefono Notificaciones', label: 'Teléfono Notificaciones', selected: true },
                { key: 'N Asistentes', label: 'N° Asistentes', selected: true },
                { key: 'Estado de la actividad', label: 'Estado de la actividad', selected: true },
                { key: 'Coordinador Evento', label: 'Coordinador', selected: true },
                { key: 'Participantes', label: 'Participantes', selected: true },
                { key: 'Observacion', label: 'Observación', selected: true },
                { key: 'Unidad', label: 'Unidad', selected: true }
            ],
            unidadesColores: {
                'DAE PM': '#01B0BB',
                'DAE Valdivia': '#008C95',
                'Admision y Matricula': '#008000',
                'Difusion': '#00A000',
                'Difusion PM': '#FFC738',
                'Sin Unidad': '#6B3D3D'
            }
        };
    },
    validations: {
        event: {
            title: { required },
            category: { required }
        }
    },
    watch: {
        sede() {
            this.actualizarCoordinadores();
        }
    },
    methods: {
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        /**
         * Modal form submit
         */
        labelselect ({ name }) {
            return `${name}`
        },
        /**
         * Modal open for edit event
         */
        editEvent(info) { //mostrara info del evento
            console.log(info);
            this.edit = info.event;
            this.editevent = {
                ...this.edit.extendedProps,
                codigo: (this.edit.extendedProps && this.edit.extendedProps.codigo) || '',
                rbd_colegio: (this.edit.extendedProps && this.edit.extendedProps.rbd_colegio) || '',
                colegio: (this.edit.extendedProps && this.edit.extendedProps.colegio) || '',
                comuna: (this.edit.extendedProps && this.edit.extendedProps.comuna) || ''
            };
            this.completarComunaDesdeRbd();
            this.eventModal = true;
        },
        async completarComunaDesdeRbd() {
            if (this.editevent.comuna && String(this.editevent.comuna).trim() !== '') {
                return;
            }
            const eventoLocal = (this.calendarEvents || []).find((evento) => String(evento.codigo) === String(this.editevent.codigo));
            if (eventoLocal && eventoLocal.comuna && String(eventoLocal.comuna).trim() !== '') {
                this.editevent.comuna = eventoLocal.comuna;
                return;
            }

            const rbdCandidatos = [this.editevent.rbd_colegio, eventoLocal ? eventoLocal.rbd_colegio : null]
                .filter((rbd) => rbd !== null && rbd !== undefined && String(rbd).trim() !== '');

            for (const rbd of rbdCandidatos) {
                try {
                    const response = await axios.get(`/api/get_colegio/${encodeURIComponent(String(rbd))}`);
                    if (response.data && response.data.estado && response.data.colegio && response.data.colegio.comuna) {
                        this.editevent.comuna = response.data.colegio.comuna;
                        return;
                    }
                } catch (e) {}
            }

            if (this.editevent.colegio && String(this.editevent.colegio).trim() !== '') {
                try {
                    const response = await axios.get('/api/get_colegios');
                    const colegios = (response.data && response.data.colegios) ? response.data.colegios : [];
                    const colegioEncontrado = colegios.find((colegio) =>
                        String(colegio.nombre || '').trim().toLowerCase() === String(this.editevent.colegio || '').trim().toLowerCase()
                    );
                    if (colegioEncontrado && colegioEncontrado.comuna) {
                        this.editevent.comuna = colegioEncontrado.comuna;
                    }
                } catch (e) {}
            }
        },
        closeModal() {
            this.eventModal = false;
        },
        get_data(){
            this.isLoading = true;
            axios.get('/api/get_proximos_eventos').then(res => {
                let eventos = [];
                if (this.user.rol=='Admin') {
                    eventos = res.data.eventos;
                }else if(this.user.rol=='Supervisor'){
                    eventos = res.data.eventos;
                }else if(this.user.rol=='Coordinador'){
                    eventos = res.data.eventos.filter((us) => us.user_id == this.user.id);
                }

                // Aplicar colores según la unidad
                this.calendarEvents = eventos.map(evento => {
                    const unidadNormalizada = this.normalizarUnidad(evento.unidad);
                    return {
                        ...evento,
                        unidad: unidadNormalizada,
                        className: 'text-white',
                        backgroundColor: this.obtenerColorUnidad(unidadNormalizada),
                        borderColor: this.obtenerColorUnidad(unidadNormalizada)
                    };
                });

                this.calendarEventsFiltrados = [...this.calendarEvents];
                this.sedes = [];
                this.allCoordinadores = this.calendarEvents
                    .filter(item => item.coordinador_evento && item.coordinador_evento !== 'null' && item.coordinador_evento !== '')
                    .map(item => ({ nombre: item.coordinador_evento }));
                this.actualizarCoordinadores();
            }).catch(e => {
                this.isLoading = false;
            });
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        filtrarEventos() {
            let eventosFiltrados = this.calendarEvents;
            if (this.coordinador) {
                eventosFiltrados = eventosFiltrados.filter(evento => evento.coordinador_evento === this.coordinador);
            }
            if (this.unidad) {
                const unidadFiltro = this.normalizarUnidad(this.unidad);
                eventosFiltrados = eventosFiltrados.filter(evento => this.normalizarUnidad(evento.unidad) === unidadFiltro);
            }
            this.calendarEventsFiltrados = eventosFiltrados.map(evento => {
                const unidadNormalizada = this.normalizarUnidad(evento.unidad);
                return {
                    ...evento,
                    unidad: unidadNormalizada,
                    className: 'text-white',
                    backgroundColor: this.obtenerColorUnidad(unidadNormalizada),
                    borderColor: this.obtenerColorUnidad(unidadNormalizada)
                };
            });
        },
        obtenerTipoNombre(tipoValor) {
            const tipoEncontrado = this.tipos.find((tipo) => String(tipo.id) === String(tipoValor) || String(tipo.codigo) === String(tipoValor));
            return tipoEncontrado ? tipoEncontrado.nombre : (tipoValor || '');
        },
        obtenerEstadoActividadTexto(valor) {
            if (Array.isArray(valor)) {
                const primerEstado = valor[0];
                return primerEstado && (primerEstado.nombre || primerEstado.codigo || primerEstado) || '';
            }
            if (valor && typeof valor === 'object') {
                return valor.nombre || valor.codigo || '';
            }
            return valor || '';
        },
        normalizarUnidad(unidad) {
            const valor = String(unidad || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase();

            const mapaUnidades = {
                'dae': 'DAE PM',
                'dae pm': 'DAE PM',
                'dae valdivia': 'DAE Valdivia',
                'admision y matricula': 'Admision y Matricula',
                'difusion': 'Difusion',
                'difusion pm': 'Difusion PM',
                'sin unidad': 'Sin Unidad'
            };

            return mapaUnidades[valor] || (valor ? String(unidad).trim() : 'Sin Unidad');
        },
        obtenerColorUnidad(unidad) {
            const unidadNormalizada = this.normalizarUnidad(unidad);
            return this.unidadesColores[unidadNormalizada] || this.unidadesColores['Sin Unidad'];
        },
        obtenerParticipantesTexto(valor) {
            if (!valor) return '';
            let participantes = valor;
            if (typeof participantes === 'string') {
                try {
                    participantes = JSON.parse(participantes);
                } catch (e) {
                    return participantes;
                }
            }
            if (!Array.isArray(participantes)) {
                participantes = [participantes];
            }
            return participantes
                .map((participante) => {
                    if (typeof participante === 'string') return participante;
                    if (participante && typeof participante === 'object') {
                        return participante.name || participante.nombre || participante.codigo || '';
                    }
                    return '';
                })
                .filter((participante) => String(participante).trim() !== '')
                .join('; ');
        },
        abrirModalColumnas(tipo = 'mes') {
            this.tipoDescarga = tipo;
            this.showColumnModal = true;
        },
        toggleAllColumns(select) {
            this.availableColumns.forEach(col => col.selected = select);
        },
        handleModalOk(bvModalEvent) {
            // Prevenir el cierre automático del modal
            bvModalEvent.preventDefault();
            // Ejecutar la descarga según el tipo
            if (this.tipoDescarga === 'anio') {
                this.confirmarDescargaAnio();
            } else {
                this.confirmarDescargaMes();
            }
        },
        descargarExcelMes() {
            this.abrirModalColumnas();
        },
        obtenerConfiguracionExportacion() {
            return {
                datosCompletos: {
                    'Actividad': (evento) => evento.nombre_difusion || evento.title || '',
                    'Codigo': (evento) => evento.codigo || '',
                    'Fecha Inicio': (evento) => evento.fecha_inicio || (evento.start ? moment(evento.start).format('YYYY-MM-DD HH:mm:ss') : ''),
                    'Fecha Termino': (evento) => evento.fecha_termino || (evento.end ? moment(evento.end).format('YYYY-MM-DD HH:mm:ss') : ''),
                    'Colegio': (evento) => evento.colegio || '',
                    'Comuna': (evento) => evento.comuna || '',
                    'Tipo': (evento) => this.obtenerTipoNombre(evento.tipo) || (evento.tipo_otro ? `Otro: ${evento.tipo_otro}` : ''),
                    'Curso': (evento) => evento.cursos || evento.curso_multi || '',
                    'Correo Notificaciones': (evento) => evento.correo_notificaciones || '',
                    'Telefono Notificaciones': (evento) => evento.telefono_notificaciones || '',
                    'N Asistentes': (evento) => evento.num_asistentes || '',
                    'Estado de la actividad': (evento) => this.obtenerEstadoActividadTexto(evento.estado_actividad),
                    'Coordinador Evento': (evento) => evento.coordinador_evento || '',
                    'Participantes': (evento) => this.obtenerParticipantesTexto(evento.participantes),
                    'Observacion': (evento) => evento.observ || '',
                    'Unidad': (evento) => evento.unidad || 'Sin Unidad'
                },
                anchos: {
                    'Actividad': 40,
                    'Codigo': 14,
                    'Fecha Inicio': 22,
                    'Fecha Termino': 22,
                    'Colegio': 36,
                    'Comuna': 24,
                    'Tipo': 22,
                    'Curso': 22,
                    'Correo Notificaciones': 35,
                    'Telefono Notificaciones': 24,
                    'N Asistentes': 20,
                    'Estado de la actividad': 24,
                    'Coordinador Evento': 28,
                    'Participantes': 35,
                    'Observacion': 40,
                    'Unidad': 25
                }
            };
        },
        confirmarDescargaMes() {
            const columnasSeleccionadas = this.availableColumns.filter(col => col.selected);

            if (columnasSeleccionadas.length === 0) {
                this.$toasted.error('Debes seleccionar al menos una columna');
                return;
            }

            const calendarApi = this.$refs.fullCalendar && this.$refs.fullCalendar.getApi
                ? this.$refs.fullCalendar.getApi()
                : null;
            const fechaReferencia = calendarApi ? calendarApi.getDate() : new Date();
            const mesReferencia = moment(fechaReferencia).month();
            const anioReferencia = moment(fechaReferencia).year();
            const { datosCompletos, anchos } = this.obtenerConfiguracionExportacion();

            const actividadesMes = this.calendarEventsFiltrados
                .filter((evento) => {
                    const fechaEvento = evento.fecha_inicio || evento.start;
                    return fechaEvento && moment(fechaEvento).isValid() && moment(fechaEvento).month() === mesReferencia && moment(fechaEvento).year() === anioReferencia;
                })
                .map((evento) => {
                    const fila = {};
                    columnasSeleccionadas.forEach(col => {
                        fila[col.label] = datosCompletos[col.key](evento);
                    });
                    return fila;
                });

            if (actividadesMes.length === 0) {
                this.$toasted.error('No hay actividades para descargar en el mes seleccionado.');
                this.showColumnModal = false;
                return;
            }

            const hoja = XLSX.utils.json_to_sheet(actividadesMes);
            const anchoColumnas = columnasSeleccionadas.map(col => ({ wch: anchos[col.key] || 20 }));
            hoja['!cols'] = anchoColumnas;
            const libro = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(libro, hoja, 'Actividades');
            const nombreArchivo = `actividades_${moment(fechaReferencia).format('YYYY_MM')}.xlsx`;
            XLSX.writeFile(libro, nombreArchivo);

            this.showColumnModal = false;
            this.$toasted.success('Archivo descargado exitosamente');
        },
        descargarExcelAnio() {
            this.abrirModalColumnas('anio');
        },
        confirmarDescargaAnio() {
            const columnasSeleccionadas = this.availableColumns.filter(col => col.selected);

            if (columnasSeleccionadas.length === 0) {
                this.$toasted.error('Debes seleccionar al menos una columna');
                return;
            }

            const calendarApi = this.$refs.fullCalendar && this.$refs.fullCalendar.getApi
                ? this.$refs.fullCalendar.getApi()
                : null;
            const fechaReferencia = calendarApi ? calendarApi.getDate() : new Date();
            const anioReferencia = moment(fechaReferencia).year();
            const { datosCompletos, anchos } = this.obtenerConfiguracionExportacion();

            const actividadesAnio = this.calendarEventsFiltrados
                .filter((evento) => {
                    const fechaEvento = evento.fecha_inicio || evento.start;
                    return fechaEvento && moment(fechaEvento).isValid() && moment(fechaEvento).year() === anioReferencia;
                })
                .map((evento) => {
                    const fila = {};
                    columnasSeleccionadas.forEach(col => {
                        fila[col.label] = datosCompletos[col.key](evento);
                    });
                    return fila;
                });

            if (actividadesAnio.length === 0) {
                this.$toasted.error('No hay actividades para descargar en el año seleccionado.');
                this.showColumnModal = false;
                return;
            }

            const hoja = XLSX.utils.json_to_sheet(actividadesAnio);
            const anchoColumnas = columnasSeleccionadas.map(col => ({ wch: anchos[col.key] || 20 }));
            hoja['!cols'] = anchoColumnas;
            const libro = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(libro, hoja, 'Actividades');
            const nombreArchivo = `actividades_${moment(fechaReferencia).format('YYYY')}.xlsx`;
            XLSX.writeFile(libro, nombreArchivo);

            this.showColumnModal = false;
            this.$toasted.success('Archivo descargado exitosamente');
        },
        actualizarCoordinadores() {
            this.coordinadores = [...new Set(this.allCoordinadores.map(c => c.nombre))];
            if (!this.coordinadores.includes(this.coordinador)) {
                this.coordinador = '';
            }
        },
        handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        },
        obtenerIdEventoPorCodigo(codigo) {
            const evento = (this.calendarEvents || []).find((ev) => String(ev.codigo) === String(codigo));
            return evento ? evento.id : null;
        },
        eliminar(codigo){
            const idEvento = this.obtenerIdEventoPorCodigo(codigo) || codigo;
            if (!idEvento) {
                Swal.fire({
                    title: 'No se puede eliminar',
                    text: 'No se encontró el id del evento desde el código enviado.',
                    icon: 'warning',
                    confirmButtonColor: '#40afd8',
                    confirmButtonText: 'Aceptar',
                });
                return;
            }

            Swal.fire({
                title: '¿Estas seguro que deseas eliminar el evento?',
                text: "Esto no se podrá revertir",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#40afd8',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, estoy seguro',
                cancelButtonText: 'Cancelar',
                }).then((result) => {
                if (result.isConfirmed) {
                    let formData = new FormData();
                    formData.append('id', idEvento);
                    axios.post('/api/eliminar_evento',formData).then(res=>{
                        if (res.data.estado) {
                            Swal.fire({
                                title: 'Eliminado',
                                text: "Evento eliminado",
                                icon: 'success',
                                confirmButtonColor: '#40afd8',
                                confirmButtonText: 'Aceptar',
                            });
                            this.eventModal = false;
                            this.get_data();
                        }else{
                            Swal.fire({
                                title: 'No se puede eliminar',
                                text: res.data.mensaje,
                                icon: 'warning',
                                confirmButtonColor: '#40afd8',
                                confirmButtonText: 'Aceptar',
                            })
                        }

                    });
                }
            });
        },
    },
    mounted() {
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
        this.get_data();
    },
    created(){
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<template>
    <div>
        <div class="row" v-if="user.rol=='Admin' || user.rol=='Supervisor'">
            <div class="col-md-12">
                <div class="card bg-soft-primary">
                    <div class="card-body">
                        <div class="row align-items-end">
                            <div class="col-md-3" v-if="user.rol=='Admin'">
                                <b-form-group label="Sede :" label-for="sede-select" class="mb-3">
                                    <multiselect
                                        v-model="sede"
                                        :options="sedes"
                                        placeholder="Seleccionar sede"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div :class="user.rol=='Supervisor'?'col-md-4':'col-md-3'">
                                <b-form-group label="Coordinador :" label-for="coordinador-select" class="mb-3">
                                    <multiselect
                                        v-model="coordinador"
                                        :options="coordinadores"
                                        placeholder="Seleccionar coordinador"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div :class="user.rol=='Supervisor'?'col-md-4':'col-md-3'">
                                <b-form-group label="Unidad :" label-for="unidad-select" class="mb-3">
                                    <multiselect
                                        v-model="unidad"
                                        :options="unidades"
                                        placeholder="Seleccionar unidad"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div :class="user.rol=='Supervisor'?'col-md-4':'col-md-3'">
                                <b-button variant="primary" block class="mb-3" @click="filtrarEventos">Filtrar</b-button>
                            </div>
                        </div>

                        <!-- Leyenda de colores por unidad -->
                        <div class="row">
                            <div class="col-md-12">
                                <div class="d-flex flex-wrap align-items-center">
                                    <span class="mr-3 font-weight-semibold">Unidades:</span>
                                    <span class="badge mr-2 mb-1" :style="{backgroundColor: unidadesColores['DAE PM'], color: 'white', padding: '6px 12px'}">DAE PM</span>
                                    <span class="badge mr-2 mb-1" :style="{backgroundColor: unidadesColores['DAE Valdivia'], color: 'white', padding: '6px 12px'}">DAE Valdivia</span>
                                    <span class="badge mr-2 mb-1" :style="{backgroundColor: unidadesColores['Admision y Matricula'], color: 'white', padding: '6px 12px'}">Admisión y Matrícula</span>
                                    <span class="badge mr-2 mb-1" :style="{backgroundColor: unidadesColores['Difusion'], color: 'white', padding: '6px 12px'}">Difusión</span>
                                    <span class="badge mr-2 mb-1" :style="{backgroundColor: unidadesColores['Difusion PM'], color: 'white', padding: '6px 12px'}">Difusión PM</span>
                                    <span class="badge mr-2 mb-1" :style="{backgroundColor: unidadesColores['Sin Unidad'], color: 'white', padding: '6px 12px'}">Sin Unidad</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <b-button variant="primary" class="mr-2" @click="abrirModalColumnas">Descargar Mes</b-button>
                        <b-button variant="primary" @click="descargarExcelAnio">Descargar Año</b-button>
                        <div class="app-calendar">
                            <FullCalendar
                                ref="fullCalendar"
                                default-view="dayGridMonth"
                                locale= "es"
                                :firstDay='1'
                                :buttonText="{ today:'Hoy', month:'Mes', week:'Semana',day:'Dia',list:'Lista' }"
                                :header="{ left: 'prev,next today',center: 'title',right: 'dayGridMonth,timeGridWeek,timeGridDay' }"
                                :editable="false"
                                :droppable="false"
                                :plugins="calendarPlugins"
                                :events="calendarEventsFiltrados"
                                :weekends="calendarWeekends"
                                :theme-system="themeSystem"
                                :eventTimeFormat="eventTimeFormat"
                                @eventClick="editEvent"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Modal -->
        <b-modal
        v-model="eventModal"
        title="Información Evento"
        title-class="text-black font-18"
        hide-footer
        body-class="p-4"
        >
            <div class="row">
                <div class="col-md-12">
                    <p class="font-size-16"><strong>Actividad:</strong> {{ editevent.nombre_difusion }}</p>
                    <p class="font-size-16"><strong>Código:</strong> {{ editevent.codigo }}</p>
                    <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ editevent.fecha_inicio }}</p><!--con hora -->
                    <p class="font-size-16"><strong>Fecha de término:</strong> {{ editevent.fecha_termino }}</p>
                    <p class="font-size-16 d-flex align-items-center" >
                        <strong>RBD:</strong> {{ editevent.rbd_colegio }}
                    </p>
                    <p class="font-size-16"><strong>Colegio:</strong> {{ editevent.colegio }}</p>
                    <p class="font-size-16"><strong>Comuna:</strong> {{ editevent.comuna || '-' }}</p>
                    <p class="font-size-16"><strong>Coordinador Evento:</strong> {{ editevent.coordinador_evento }}</p>
                    <p class="font-size-16">
                        <strong>Unidad:</strong>
                        <span class="badge" :style="{backgroundColor: obtenerColorUnidad(editevent.unidad), color: 'white', padding: '4px 10px'}">
                            {{ normalizarUnidad(editevent.unidad) }}
                        </span>
                    </p>
                </div>
            </div>
            <div class="text-right p-3">
                <b-button variant="light" @click="closeModal">Cerrar</b-button>
                <b-button variant="primary" @click="ver_evento(editevent.codigo)">Ir al Evento</b-button>
                <b-button variant="danger" @click="eliminar(editevent.codigo)"><i class="bx bx-trash"></i> Eliminar</b-button>
            </div>
        </b-modal>

        <!-- Modal de selección de columnas -->
        <b-modal v-model="showColumnModal" :title="`Seleccionar Columnas para Descargar ${tipoDescarga === 'anio' ? 'Año' : 'Mes'}`" size="lg" @ok="handleModalOk" ok-title="Descargar" cancel-title="Cancelar">
            <div class="mb-3">
                <b-button variant="outline-primary" size="sm" class="mr-2" @click="toggleAllColumns(true)">Seleccionar Todas</b-button>
                <b-button variant="outline-secondary" size="sm" @click="toggleAllColumns(false)">Deseleccionar Todas</b-button>
            </div>
            <div class="row">
                <div class="col-md-6" v-for="column in availableColumns" :key="column.key">
                    <b-form-checkbox v-model="column.selected" class="mb-2">
                        {{ column.label }}
                    </b-form-checkbox>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style>
.fc-event,
.fc-day-grid-event,
.fc-time-grid-event,
.fc-list-item {
    cursor: pointer !important;
}

.fc-event-draggable,
.fc-event-resizable {
    cursor: pointer !important;
}
</style>
